module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL8AAAAHCAYAAABZc5weAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAs0lEQVRYhe3XMUoDURSG0fOGNyJETSmCWFsJLsk2K3ApLsANWNiJvaWYBVilMUqMwSQTfWPhGpyBeM8KvuLCz01t28IQlRD+hzU+0+DoLC0mj8846TkohE6UUq4Ojs9HFfaazabuOyiErry+zfaxm3F4Mbq8Xi5Xp6WU3HdYCH9pp64/1k3zgGFGdXN7N8UCsQBh271jhpTxgns8iac3bL8VJphnzDH2e/ipz6oQOlDwja8fxfYwEeXOHY4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/bannerText2.png
// module id = qlEv
// module chunks = 1